import { motion } from "framer-motion";
import styles from "./ImageSection.module.css";
import { Trans, useTranslation } from "react-i18next";
import { container, item } from "../../../utils/animations";

export const ImageSection = () => {
    const { t } = useTranslation();
    
    return (
        <section className={styles.imageWrapper}>
            <div className={styles.container}>
                <motion.div
                    className={styles.textWrapper}
                    variants={container}
                    initial="hidden"
                    whileInView="show"
                    viewport={{
                        once: true,
                        amount: 0.2,
                    }}
                >
                    <motion.h1
                        className={styles.animatedMainText}
                        variants={item}
                    >
                        <Trans
                            i18nKey="home.landingTitle"
                            components={[
                                <span className={styles.textCoursive} />
                            ]}
                        />
                    </motion.h1>
                    <motion.h2 
                        className={styles.animatedText}
                        variants={item}
                    >
                        {t('home.landingSubTitle')}
                    </motion.h2>
                    <motion.div
                        className={styles.bottomWrapper}
                        variants={item}
                    >
                        <motion.div
                            className={styles.buttonsWrapper}
                            variants={item}
                            >
                            <motion.img
                                src={require("../../../../assets/images/img-app-store.png")}
                                alt="Download on the App Store"
                                className={styles.appStoreImage}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() =>
                                    window.open(
                                        "https://apps.apple.com/es/app/gluten-freends/id6479203808",
                                        "_blank"
                                    )
                                }
                            />

                            <motion.img
                                src={require("../../../../assets/images/img-google-play.png")}
                                alt="Download on Google Play"
                                className={styles.googlePlayImage}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() =>
                                    window.open(
                                        "https://play.google.com/store/apps/details?id=com.glutenfreehub.app",
                                        "_blank"
                                    )
                                }
                            />
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};